import { render, staticRenderFns } from "./DoctorTable.vue?vue&type=template&id=6de4f8b7&scoped=true"
import script from "./DoctorTable.vue?vue&type=script&lang=js"
export * from "./DoctorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de4f8b7",
  null
  
)

export default component.exports